export const finalConverterContent = {
  title: "Don't Stay in the 83% Failure Group. Join the Top 0.12% in 12 Minutes.",
  body:
    "We don't sell software. We deploy a zero-friction safety net under your existing advertising budget. If our Roofing Digital Assistant doesn't recover at least 2 lost estimates in 14 days, you pay us $0.",
  cta: "CONNECT MY ROOFING DIGITAL ASSISTANT — START 14-DAY FREE TRIAL",
  note: "No credit card required • Installed in 12 minutes or done for you",
}
